import { render, staticRenderFns } from "./NewRadioInput.vue?vue&type=template&id=63c3fd50&scoped=true"
import script from "./NewRadioInput.vue?vue&type=script&lang=js"
export * from "./NewRadioInput.vue?vue&type=script&lang=js"
import style0 from "./NewRadioInput.vue?vue&type=style&index=0&id=63c3fd50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c3fd50",
  null
  
)

export default component.exports